<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Accettazione Livelli</span>
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + (row.index + 1) }}
                    </template>
                    <template v-slot:cell(dataOraInizio)="{ item }">
                        <span>{{ formatDateTime(item.dataOraInizio) }}</span>
                    </template>
                    <template v-slot:cell(dataOraFine)="{ item }">
                        <span>{{ formatDateTime(item.dataOraFine) }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-success" @click="onClickModificaSettingLivello(item)" title="Visualizza">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button v-if="item.dataOraFine === null" size="sm" v-b-tooltip.hover title="Concludi" variant="outline-purple sa-margin-left float-sm-left" @click="onclickConludiSettingLivello(item)"><i class="fas fa-exchange-alt"></i> </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-paziente-accettazione-setting-livelli-modal-edit-component ref="cmpRsaPazienteAccettazioneSettingLivelliModalEdit" @afterSave="onAfterSave"></rsa-paziente-accettazione-setting-livelli-modal-edit-component>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteAccettazioneSettingLivelliModalEditComponent from "./RsaPazienteAccettazioneSettingLivelliModalEditComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: {
        RsaPazienteAccettazioneSettingLivelliModalEditComponent,
    },
    props: {
        utente: { type: Object },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/accettazionersasettinglivelli",
            filtroSettingLivelli: { idAccettazione: null, tiposcale: null, dataDal: null, dataAl: null },
            idAccettazione: "",
            items: [],
            isDynamicFormView: true,
            dynamicJsonData: {},
            defaultValues: {},
            jsonDataAccettazione: {},
            fields: [
                { label: "", key: "index" },
                { label: "Setting", key: "descrizioneSetting", sortable: true, thStyle: "width: 18rem" },
                { label: "Livello", key: "descrizioneLivello", sortable: true, thStyle: "width: 18rem" },
                { label: "Data Ora Inizio", key: "dataOraInizio", sortable: true, thStyle: "width: 18rem" },
                { label: "Data Ora Fine", key: "dataOraFine", sortable: true, thStyle: "width: 18rem" },
                { label: "", key: "action", class: "sa-table-column-action-double" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(jsonDataAccettazione) {
            let me = this;
            me.idAccettazione = jsonDataAccettazione.id;
            me.jsonDataAccettazione = jsonDataAccettazione;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroSettingLivelli"]) {
                me.filtroSettingLivelli = JSON.parse(sessionStorage["filtroSettingLivelli"]);
            }
            me.filtroSettingLivelli.idAccettazione = me.idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.filtroSettingLivelli.page = me.currentPage;
            me.filtroSettingLivelli.forPage = me.perPage;
            me.openShowModalLoading();
            me.loadDataResources(me.pathResource, me.filtroSettingLivelli, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.closeShowModalLoading();
        },
        loadDataError(error) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle scale", error.response.data.messaggio ? error.response.data.messaggio : "", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.closeShowModalLoading();
        },
        onClickAggiungi() {
            let me = this;
            me.$refs.cmpRsaPazienteAccettazioneSettingLivelliModalEdit.show(null, me.jsonDataAccettazione, "NUOVO");
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        onClickModificaSettingLivello(item) {
            let me = this;
            me.$refs.cmpRsaPazienteAccettazioneSettingLivelliModalEdit.show(item, me.jsonDataAccettazione, "MODIFICA");
        },
        onclickConludiSettingLivello(item) {
            let me = this;
            me.$refs.cmpRsaPazienteAccettazioneSettingLivelliModalEdit.show(item, me.jsonDataAccettazione, "CHIUSURA");
        },
    },
};
</script>

<style></style>
